function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 19c4.971 0 9-4.029 9-9s-4.029-9-9-9-9 4.029-9 9 4.029 9 9 9Zm5.189-11.085a1.5 1.5 0 0 0-2.378-1.829L8.762 11.35 6.96 9.849a1.501 1.501 0 0 0-1.921 2.305l4.198 3.498 5.951-7.736Z",
    style: {
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
};
export default SvgCheckCircle;